'use strict';

var _forEach = require('lodash/forEach');

var _forEach2 = _interopRequireDefault(_forEach);

var _first = require('lodash/first');

var _first2 = _interopRequireDefault(_first);

var _isArray = require('lodash/isArray');

var _isArray2 = _interopRequireDefault(_isArray);

var _configUtils = require('../utils/configUtils');

var _configUtils2 = _interopRequireDefault(_configUtils);

var _constants = require('../utils/constants');

var _constants2 = _interopRequireDefault(_constants);

var _applicationState = require('../utils/applicationState');

var _applicationState2 = _interopRequireDefault(_applicationState);

var _adsSettings = require('../utils/adsSettings');

var _adsSettings2 = _interopRequireDefault(_adsSettings);

var _truexNetworkController = require('../ads/networks/truexNetworkController');

var _truexNetworkController2 = _interopRequireDefault(_truexNetworkController);

var _adSlotManager = require('../ads/adSlotManager');

var _adSlotManager2 = _interopRequireDefault(_adSlotManager);

var _slotEvents = require('../ads/slotEvents');

var _slotEvents2 = _interopRequireDefault(_slotEvents);

var _googletag = require('../bootstrap/googletag');

var _googletag2 = _interopRequireDefault(_googletag);

var _lotameNetworkController = require('../targeting/lotameNetworkController');

var _lotameNetworkController2 = _interopRequireDefault(_lotameNetworkController);

var _palSdkController = require('../targeting/palSdkController');

var _palSdkController2 = _interopRequireDefault(_palSdkController);

var _adInterface = require('../ads/adInterface');

var _adInterface2 = _interopRequireDefault(_adInterface);

var _prerollAdController = require('../ads/controllers/prerollAdController');

var _prerollAdController2 = _interopRequireDefault(_prerollAdController);

var _displayAdController = require('../ads/controllers/display/displayAdController');

var _displayAdController2 = _interopRequireDefault(_displayAdController);

var _InstreamAvailsController = require('../ads/controllers/instream/InstreamAvailsController');

var _InstreamAvailsController2 = _interopRequireDefault(_InstreamAvailsController);

var _fallbackAdsController = require('../ads/controllers/fallbackAdsController');

var _fallbackAdsController2 = _interopRequireDefault(_fallbackAdsController);

var _logger = require('../logging/logger');

var _logger2 = _interopRequireDefault(_logger);

var _stackAdapt = require('../pixels/stackAdapt');

var _stackAdapt2 = _interopRequireDefault(_stackAdapt);

var _getAdTypeControllerFromFormat = require('../utils/getAdTypeControllerFromFormat');

var _getAdTypeControllerFromFormat2 = _interopRequireDefault(_getAdTypeControllerFromFormat);

var _getAdTypeControllerFromSlot = require('../utils/getAdTypeControllerFromSlot');

var _getAdTypeControllerFromSlot2 = _interopRequireDefault(_getAdTypeControllerFromSlot);

var _prerollUtils = require('../utils/prerollUtils');

var _prerollUtils2 = _interopRequireDefault(_prerollUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

_googletag2.default.bootstrap();

// public interface
var mint = {
  init: function init(settings) {
    // initialize global settings
    _applicationState2.default.init(settings);

    // initialize ad type controllers
    _displayAdController2.default.init();
    _fallbackAdsController2.default.init();
    _truexNetworkController2.default.init();
    _prerollAdController2.default.init();
    _lotameNetworkController2.default.init();

    // initialize Google Programmatic Access Libraries SDK
    _palSdkController2.default.init();

    // initialize ad-to-mint interface
    _adInterface2.default.init();

    this.setCanShowAds();

    // check config setting to see if InStreamAdsController is enabled
    this.instreamAvailsController = new _InstreamAvailsController2.default();

    this.onProfileChange = this.onProfileChange.bind(this);
    this.onCanShowAdsChange = this.onCanShowAdsChange.bind(this);
    this.updateInstreamParams = this.updateInstreamParams.bind(this);

    (0, _applicationState.addStateChangeListener)(_applicationState.State.selectedGuideId, this.onProfileChange);
    (0, _applicationState.addStateChangeListener)(_applicationState.State.playerStatus, this.onCanShowAdsChange);
    (0, _applicationState.addStateChangeListener)(_applicationState.State.adsEnabled, this.onCanShowAdsChange);
    (0, _applicationState.addStateChangeListener)(_applicationState.State.lotamesegments, this.updateInstreamParams);

    // initialize the pixels!
    _stackAdapt2.default.init();
  },
  setCanShowAds: function setCanShowAds() {
    this.canShowAds = _adsSettings2.default.canShowAds();
  },
  handleInstreamAds: function handleInstreamAds(adData) {
    _logger2.default.debug('mint | received instream ad data', adData);
    this.instreamAvailsController.processAdData(adData);
  },
  registerSlot: function registerSlot(elementId, slotName, dimensions) {
    var screenName = (0, _applicationState.getState)(_applicationState.State.currentScreen);
    if (!(0, _applicationState.getState)(_applicationState.State.isInitialized) ||
    // abort if slot already registered
    _adSlotManager2.default.getSlot(elementId) ||
    // don't register ads for screens they don't belong on
    !_configUtils2.default.isValidSlotForScreen(slotName, screenName)) {
      return;
    }

    var slot = _adSlotManager2.default.addSlot(slotName, elementId, dimensions);

    if (!slot) {
      return;
    }

    var formatDefinition = (0, _isArray2.default)(slot.formats) ? (0, _first2.default)(slot.formats) : slot.formats;
    var adTypeController = (0, _getAdTypeControllerFromFormat2.default)(formatDefinition);
    if (adTypeController && !adTypeController.isRegistered(slot)) {
      adTypeController.registerSlot(slot);
    }
    _fallbackAdsController2.default.registerSlot(slot);
  },
  deregisterSlot: function deregisterSlot(elementId) {
    if (!(0, _applicationState.getState)(_applicationState.State.isInitialized)) {
      return;
    }

    var slot = _adSlotManager2.default.getSlot(elementId);
    if (slot && slot.formatDefinition) {
      var adTypeController = (0, _getAdTypeControllerFromSlot2.default)(slot);
      if (adTypeController && adTypeController.isRegistered(slot)) {
        adTypeController.releaseSlot(slot);
        adTypeController.deregisterSlot(slot);
      }
      _fallbackAdsController2.default.releaseSlot(slot);
      _fallbackAdsController2.default.deregisterSlot(slot);
    }
    _adSlotManager2.default.removeSlot(elementId);
  },
  clearSlot: function clearSlot(elementId, shouldIgnoreAdVisibilityEventOnce) {
    if (!(0, _applicationState.getState)(_applicationState.State.isInitialized)) {
      return;
    }

    var slot = _adSlotManager2.default.getSlot(elementId);
    if (slot && slot.formatDefinition) {
      var adTypeController = (0, _getAdTypeControllerFromSlot2.default)(slot);
      if (adTypeController && adTypeController.isRegistered(slot) && adTypeController.clearSlot) {
        adTypeController.clearSlot(slot, shouldIgnoreAdVisibilityEventOnce);
      }
    }
  },

  requestSlot: function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(elementId) {
      var _this = this;

      var slot, slotName, formatDefinition, adTypeController, screenName, refreshSlot;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(!(0, _applicationState.getState)(_applicationState.State.isInitialized) || !(0, _applicationState.getState)(_applicationState.State.adsEnabled))) {
                _context.next = 2;
                break;
              }

              return _context.abrupt('return');

            case 2:
              slot = _adSlotManager2.default.getSlot(elementId);

              if (slot) {
                _context.next = 5;
                break;
              }

              return _context.abrupt('return');

            case 5:
              slotName = slot.name;
              formatDefinition = (0, _first2.default)(_configUtils2.default.getFormatDefinitionsBySlotName(slotName));
              adTypeController = (0, _getAdTypeControllerFromFormat2.default)(formatDefinition);
              screenName = (0, _applicationState.getState)(_applicationState.State.currentScreen);

              if (!(!formatDefinition || !adTypeController || !_configUtils2.default.isValidSlotForScreen(slotName, screenName))) {
                _context.next = 11;
                break;
              }

              return _context.abrupt('return');

            case 11:

              // make sure current network controller releases any lingering actions before serving
              if (slot.adTypeController) {
                slot.adTypeController.releaseSlot(slot);
              }

              slot.formatDefinition = formatDefinition;
              slot.adTypeController = adTypeController;

              // remove and re-add listener for cases when we call requestSlot to force a refresh

              refreshSlot = function refreshSlot() {
                return _this.requestSlot(elementId);
              };

              slot.off(_slotEvents2.default.refresh);
              slot.once(_slotEvents2.default.refresh, refreshSlot);

              if (!adTypeController.isRegistered(slot)) {
                adTypeController.registerSlot(slot);
              }

              _context.next = 20;
              return adTypeController.serveAd({ slot: slot, adTypeController: adTypeController });

            case 20:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function requestSlot(_x) {
      return _ref.apply(this, arguments);
    }

    return requestSlot;
  }(),
  requestPremiumUnlockActivity: function requestPremiumUnlockActivity(params) {
    var slotName = params.slotName,
        elementId = params.elementId;


    var slot = _adSlotManager2.default.getSlot(elementId);
    if (!slot) {
      this.registerSlot(elementId, slotName);
      slot = _adSlotManager2.default.getSlot(elementId);
    }

    params.slot = slot;
    _truexNetworkController2.default.serveAd(params);
  },
  triggerLotameTargeting: function triggerLotameTargeting(interests) {
    _lotameNetworkController2.default.triggerLotameTargeting(interests);
  },
  addLotameInterests: function addLotameInterests(interests) {
    _lotameNetworkController2.default.addInterests(interests);
  },
  updateState: function updateState(stateName, value) {
    (0, _applicationState.updateState)(stateName, value);
  },
  updateUnlockDetails: function updateUnlockDetails(value) {
    _applicationState2.default.updateUnlockDetails(value);
  },
  getState: function getState(stateName) {
    return (0, _applicationState.getState)(stateName);
  },
  requestAllDisplaySlots: function requestAllDisplaySlots() {
    var _this2 = this;

    if (_adsSettings2.default.canShowAds() && !this.canShowAds) {
      (0, _forEach2.default)(_adSlotManager2.default.getSlots(), function (slot) {
        if (slot.medium === _constants2.default.MediumTypes.display) {
          _this2.requestSlot(slot.elementId);
        }
      });
    }
  },
  onCanShowAdsChange: function onCanShowAdsChange() {
    this.requestAllDisplaySlots();
    this.setCanShowAds();
  },
  updateInstreamParams: function updateInstreamParams() {
    this.instreamAvailsController.updateInstreamParams();
  },

  /**
   * Handles state updates to selectedGuideId. Does not request display slots if the user is
   * navigating away from the profile page, indicated by an undefined selectedGuideId value.
   *
   * @param {string} [selectedGuideId] - The guide ID set by the Profile component in Gemini-Web
   */
  onProfileChange: function onProfileChange(selectedGuideId) {
    if (selectedGuideId) {
      this.requestAllDisplaySlots();
    }

    this.setCanShowAds();
    this.updateInstreamParams();
  },
  disableAds: function disableAds() {
    (0, _applicationState.updateState)(_applicationState.State.adsEnabled, false);
  },
  preload: function preload() {
    var _this3 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _prerollAdController2.default.preload();

            case 2:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this3);
    }))();
  },
  play: function play() {
    _prerollAdController2.default.play();
  },
  pause: function pause() {
    _prerollAdController2.default.pause();
  },
  stop: function stop() {
    _prerollAdController2.default.stop();
  },
  volume: function volume(_volume) {
    _prerollAdController2.default.volume(_volume);
  },
  resize: function resize(width, height) {
    _prerollAdController2.default.resize(width, height);
  },
  getPalNonce: function getPalNonce() {
    return _palSdkController2.default.getNonce();
  },
  hasMetPrerollQuota: function hasMetPrerollQuota() {
    return _prerollUtils2.default.prerollAlreadyPlayed();
  }
};

module.exports = mint;